import { BiSolidXSquare } from "react-icons/bi";
import style from "./MenuHamburguer.module.css";

function MenuHamburguer({ menuHamburguerAberto, setMenuHamburguerAberto }) {
  return (
    <button
      className={style.menuHamburguerBotao}
      onClick={() => setMenuHamburguerAberto(!menuHamburguerAberto)}
      aria-label="Alternar menu"
      type="button"
    >
    <BiSolidXSquare color="#001E81" size={50}  />
    </button>
  );
}

export default MenuHamburguer;
